export default function acceptNowOrders(store: {
  disableNowOrders?: boolean
}): boolean {
  return store?.disableNowOrders !== true
}
